import { api } from '../lib/api'

export type ProsConsoleSummary = {
  pro_enabled: boolean
  pro_subscribed: boolean
  stake_pixe: number
  can_access_console: boolean
  can_access_paid_tabs: boolean
  pro_enabled_updated_at?: string | null
  visible_in_discovery?: boolean
  booking_enabled?: boolean
  pro: {
    enabled: boolean
    subscribed: boolean
    mode: 'remote' | 'onsite'
    stake_pixe: number
    title: string
    handle?: string
    display_name?: string
    hourly_rate_pixe: number
    starting_price_pixe: number | null
    available_now: boolean
    company_page_id: number | null
    rating_avg?: number | null
    rating_count?: number | null
    jobs_count_lifetime?: number | null
    earned_pixe_lifetime?: string | null
  }
  stripe: {
    deposits_connect_status: 'not_connected' | 'pending' | 'enabled'
    payouts_connect_status: 'not_connected' | 'action_required' | 'pending' | 'enabled'
  }
  counts: {
    skills?: number
    services: number
    weekly_ranges: number
    pending_requests: number
  }
}

export type ProsMarketingPayload = {
  pro_console_requires_subscription: boolean
  monthly_fee_usd: number | null
  platform_fee_default_pct: number
  stake_required: boolean
  stake_required_pixe: number
  deposit_policy: {
    required: boolean
    percent: number
    min_pixe: number
    max_pixe: number
  }
  payout_policy: {
    requires_stripe_connect: boolean
    currency: string
    note: string
  }
  benefits: string[]
  faq: Array<{ q: string; a: string }>
}

export type ProsConsoleMetrics = {
  range: { days: number | null }
  range_days?: number | null
  kpis: {
    held_pixe: string
    earned_pixe: string
    withdrawable_pixe?: string | null
    completed_jobs: number
    pending_requests: number
    avg_rating: string | null
  }
  series: {
    earned_by_day_pixe: Array<{ date: string; pixe: string }>
    held_by_day_pixe?: Array<{ date: string; pixe: string }>
    bookings_by_day: Array<{ date: string; count: number }>
  }
  recent_activity: Array<{
    type: string
    at: string | null
    title: string
    subtitle?: string | null
    amount_pixe?: string | null
    status?: string | null
    job_id?: number | null
    request_id?: number | null
  }>
}

export type ProsConsoleEarning = {
  type: string
  source: string
  title?: string
  amount_pixe?: number
  at: string | null
  job_id: number | null
  customer_handle?: string | null
}

export type ProsConsoleEarningsResponse = {
  count: number
  page: number
  page_size: number
  type: string
  kpis?: {
    held_pixe: number
    earned_released_30d_pixe: number
    earned_released_lifetime_pixe: number
    fees_30d_pixe: number
    fees_lifetime_pixe: number
    refunds_30d_pixe: number
    refunds_lifetime_pixe: number
    net_30d_pixe: number
    net_lifetime_pixe: number
    withdrawable_pixe: number
  }
  results: ProsConsoleEarning[]
}

export async function getProsConsoleSummary() {
  const { data } = await api.get<ProsConsoleSummary>('/api/pros/console/summary/')
  return data
}

export async function getProsMarketing() {
  const { data } = await api.get<ProsMarketingPayload>('/api/pros/marketing/')
  return data
}

export async function joinPros() {
  const { data } = await api.post<ProsConsoleSummary>('/api/pros/join/', {})
  return data
}

export async function getProsConsoleMetrics(days: number | 'all' = 30) {
  const { data } = await api.get<ProsConsoleMetrics>('/api/pros/console/metrics/', { params: { days } })
  return data
}

export async function getProsConsoleEarnings(params?: { page?: number; page_size?: number; type?: string }) {
  const { data } = await api.get<ProsConsoleEarningsResponse>('/api/pros/console/earnings/', { params })
  return data
}
